export class Membership {
    name: string;
  }